// 数据安全承诺页（M4 任务 4.2）· 公开访问：把「数据怎么处理」讲透，建立信任
import { Link } from "react-router-dom";
import { BrandLogo } from "../components/BrandLogo";

const SECTIONS: { icon: string; title: string; body: string[] }[] = [
  {
    icon: "🏠",
    title: "数据隔离：每人一个独立舱位",
    body: [
      "数据库启用行级安全（Row Level Security）：你的项目、方案、图片，只有你自己的账号能读写，其他用户——包括平台其他种子用户——在数据库层就无法触及。",
      "所有 API 请求都携带你本人的登录凭证，服务端逐请求校验归属，杜绝越权访问。",
    ],
  },
  {
    icon: "🔐",
    title: "传输与存储加密",
    body: [
      "全站 HTTPS，浏览器到服务器全程加密传输。",
      "文件（上传的资料、生成的 PPT）存储于独立对象存储桶，下载链接为短时签名 URL（15 分钟过期），过期即失效。",
    ],
  },
  {
    icon: "🤖",
    title: "关于 AI 大模型对资料的使用",
    body: [
      "为了生成方案，你填写的品牌资料和检索到的公开信息会发送给我们接入的国产大模型（如 DeepSeek、Kimi、GLM）进行推理生成——这是产品功能所必需的处理环节。",
      "我们仅调用各厂商的企业级 API；按各厂商 API 服务条款，API 请求内容不用于模型训练。",
      "流水线中的检索行为只针对公开网络信息，你的私有资料不会被公开发布。",
    ],
  },
  {
    icon: "📦",
    title: "你的权利：随时导出、随时删除",
    body: [
      "每一份方案都可以一键导出为标准 .pptx 文件，完整带走，不锁定在平台。",
      "如需删除账号及全部数据，联系我们后将在 3 个工作日内彻底清除（含数据库记录与存储文件）。",
    ],
  },
  {
    icon: "🛡️",
    title: "密钥与权限管理",
    body: [
      "数据库管理密钥（service role）仅存在于服务端，永不进入前端代码与浏览器。",
      "AI 模型密钥按环境隔离保管，支持随时轮换（见我们的应急预案）。",
    ],
  },
];

export default function Security() {
  return (
    <div className="min-h-screen bg-[#FAF8F4]">
      <header className="flex items-center justify-between border-b border-[#E4DFD5] bg-white px-6 py-3">
        <Link to="/" aria-label="策略咖首页"><BrandLogo /></Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/guide" className="text-muted hover:text-ink">使用引导</Link>
          <Link to="/login" className="btn-primary !py-1.5">登录</Link>
        </nav>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="text-3xl font-bold text-ink">数据安全承诺</h1>
        <p className="mt-2 text-sm text-muted">
          更新日期：2026-08-02 ｜ 适用版本：M4 种子用户版。<br />
          我们把「你的资料会被怎么处理」逐条写清楚——不藏在冗长协议里。
        </p>

        <div className="mt-8 space-y-4">
          {SECTIONS.map((s) => (
            <section key={s.title} className="card !p-5">
              <h2 className="font-bold text-ink">{s.icon} {s.title}</h2>
              {s.body.map((p, i) => (
                <p key={i} className="mt-2 text-sm leading-relaxed text-muted">{p}</p>
              ))}
            </section>
          ))}
        </div>

        <div className="card mt-6 !p-5 text-center">
          <p className="text-sm text-muted">对数据安全还有疑问？在使用中遇到任何异常？</p>
          <Link to="/login" className="btn-primary mt-3 inline-block">登录后联系我们 →</Link>
        </div>
      </main>
    </div>
  );
}
